import { Organization } from './../../models/organization';
import {
  FormGroup,
  FormControl,
  Validators,
  ValidatorFn,
  AbstractControl,
} from '@angular/forms';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-create-workspace',
  templateUrl: './create-workspace.component.html',
  styleUrls: ['./create-workspace.component.css'],
})
export class CreateWorkspaceComponent implements OnInit {
  @ViewChild('name') input!: MatInput;

  @Output() workspaceName: EventEmitter<string> = new EventEmitter();
  @Output() formDisplayed: EventEmitter<boolean> = new EventEmitter();
  @Input() iconString: string = '/assets/add_icon.svg';
  @Input() placeholderString: string = 'Type in workspace name here';
  @Input() maxLength: number = 50;
  @Input() allUserOrganizations: Organization[] = [];

  validator = new RegExp(/^[A-Za-z ]*$/);

  formDisplay: boolean = false;

  form: FormGroup = new FormGroup({
    workspaceName: new FormControl(null, [
      Validators.required,
      Validators.pattern(this.validator),
      Validators.maxLength(this.maxLength),
    ]),
  });

  constructor() {}

  ngOnInit(): void {
    if (this.allUserOrganizations.length > 0) {
      this.form.get('workspaceName')?.addValidators(
        isUniqueValue(
          this.allUserOrganizations.map((el) => {
            return el.name.toLowerCase().trim();
          })
        )
      );
      this.form.get('workspaceName')?.updateValueAndValidity();
    }
  }

  submit() {
    if (this.form.valid) {
      this.workspaceName.emit(this.form.value.workspaceName.trim());
    }
  }

  displayForm() {
    this.formDisplay = true;
    this.formDisplayed.emit(true);
    setTimeout(() => {
      if (this.input) {
        this.input.focus();
      }
    });
  }

  cancel() {
    this.form.reset();
    this.formDisplay = false;
    this.formDisplayed.emit(false);
  }
}
export const isUniqueValue = (valuesToCheck: any[]): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const controlValue = control.value;

    if (controlValue) {
      let res = !(
        valuesToCheck.indexOf(controlValue.toLowerCase().trim()) > -1
      );
      return res ? null : { notUnique: true };
    }
    return null;
  };
};
